<div class="data-sources-panel">
    <!-- Cabeçalho -->
    <div class="panel-header">
        <icon-induxtry [icon]="{icon: 'database', width: 24, height: 24}"></icon-induxtry>
        <h2 class="header-title">Fontes de Dados</h2>
    </div>

    <!-- Seletor de Conexões e Botão Adicionar -->
    <div class="connections-controls">
        <div class="connections-selector" (click)="onToggleCollapse()" role="button"
            [attr.aria-expanded]="!isCollapsedConnections" tabindex="0" (keydown.enter)="onToggleCollapse()"
            (keydown.space)="onToggleCollapse(); $event.preventDefault()">
            <span class="selector-label">Conexões</span>
            <icon-induxtry
                [icon]="{icon: isCollapsedConnections ? 'Chevron Down' : 'Chevron Up', width: 24, height: 24}"></icon-induxtry>
        </div>
        <button-induxtry [buttonProperties]="addButton" (action)="onCreateClick()">
        </button-induxtry>
    </div>

    <!-- Lista de Itens -->
    @if (!isCollapsedConnections) {
    <div class="items-list" role="list">
        @if (items.length > 0) {
        @for (item of items; track item._id) {
        <div class="item-row" role="listitem">

            <div class="item-row-content" (click)="onItemClick(item, $event)"
                (keydown.enter)="onItemClick(item, $event)"
                (keydown.space)="onItemClick(item, $event); $event.preventDefault()"
                [attr.aria-label]="'Conexão ' + item.name" tabindex="0"
                [class.selected]="isSelectedItemId === item._id">
                <!-- Indicador de Status -->
                <!-- <span class="status-indicator" [class]="getStatusClass(item.status)"
                    [attr.aria-label]="item.status === 'online' ? 'Online' : 'Offline'">
                </span> -->
                @if (item.status && connectionStatusIcon[item.status]; as statusIcon) {
                <icon-induxtry [icon]="{icon: statusIcon, width: '24px', height: '24px'}"></icon-induxtry>
                }

                <!-- Nome do Item (com tooltip para texto truncado) -->
                <span class="item-name" [title]="item.name">
                    {{ item.name }}
                </span>
            </div>

            <!-- Botão de Deletar -->
            <icon-action-button (clicked)="onDeleteClick(item, $event)" [ariaLabel]="'Excluir conexão'"
                [icon]="'delete'" [type]="'delete'" [disabled]="false">
            </icon-action-button>
        </div>
        }
        } @else {
        <div class="item-name">
            <span>Nenhuma conexão</span>
        </div>
        }
    </div>
    }
</div>